import { IntranetProject } from '../types';

// Format time as HH:MM:SS
export const formatTime = (seconds: number): string => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// Get greeting based on time of day
export const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

// Get formatted current date
export const getCurrentDate = (): string => {
  return new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Get color based on project status
const STATUS_COLORS = {
  elink: {
    over: '#ef4444',
    warning: '#f59e0b',
    caution: '#eab308',
    good: '#22c55e',
    internal: '#06b6d4',
    default: '#6b7280',
  },
  phishingbox: {
    over: '#ff6b6b',
    warning: '#fb8c00',
    caution: '#fbbf24',
    good: '#34d399',
    internal: '#00b3e5',
    default: '#7da8c4',
  },
} as const;

export type ThemeOrg = keyof typeof STATUS_COLORS;

export const getStatusColor = (
  status: string,
  themeOrg: ThemeOrg = 'elink'
): string => {
  const colors = STATUS_COLORS[themeOrg];
  return colors[status as keyof typeof colors] ?? colors.default;
};

// Get progress bar width percentage
export const getProgressWidth = (project: IntranetProject): number => {
  if (project.paidHours === 0) return 0;
  return Math.min(100, project.percentUsed);
};

// Get today's date string for filtering (YYYY-MM-DD)
export const getTodayDateString = (): string => {
  return new Date().toISOString().split('T')[0];
};

// Format session time (e.g., "9:30 AM")
export const formatSessionTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    hour12: true 
  });
};

